<template>
    <div class="flow-management-container">
        <!-- Header Section -->
        <el-card class="header-card" shadow="never">
            <el-row :gutter="20" align="middle">
                <el-col :span="24">
                    <h2 style="margin: 0; color: #303133;">Manajemen Aktivitas</h2>
                    <p style="margin: 5px 0 0 0; color: #909399; font-size: 14px;">Kelola alur kerja dan konfigurasi formulir dalam sistem</p>
                </el-col>
            </el-row>
        </el-card>

        <!-- Main Content -->
        <el-row :gutter="20">
            <!-- Flow List Section -->
            <el-col :md="8">
                <el-card shadow="never">
                    <template #header>
                        <div class="card-header">
                            <span style="font-weight: bold;">Daftar Aktivitas</span>
                            <el-button 
                                type="primary" 
                                size="small"
                                @click="showAddFlow()"
                                style="background-color: #409EFF; border-color: #409EFF; color: white;"
                            >
                                <el-icon style="margin-right: 5px;"><Plus /></el-icon>
                                Tambah
                            </el-button>
                        </div>
                    </template>
                    
                    <el-table 
                        :data="flowList" 
                        v-loading="loadingFlow" 
                        :stripe="true"
                        @row-click="selectFlow"
                        :highlight-current-row="true"
                        style="width: 100%"  
                        height="600"
                        empty-text="Tidak ada data aktivitas"
                    >
                        <el-table-column prop="group_name" label="Grup" min-width="120" show-overflow-tooltip />
                        <el-table-column prop="flow_name" label="Aktivitas" min-width="120" show-overflow-tooltip />
                        <el-table-column width="100" label="Aksi" align="center">
                            <template #default="scope">
                                <div style="display: flex; gap: 5px; justify-content: center;">
                                    <el-tooltip content="Ubah Aktivitas" placement="top">
                                        <el-button 
                                            size="small" 
                                            type="primary"
                                            style="background-color: #409EFF; border-color: #409EFF; color: white;"
                                            @click.stop="showEditFlow(scope)"
                                        >
                                            <el-icon><Edit /></el-icon>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="Hapus Aktivitas" placement="top">
                                        <el-popconfirm 
                                            title="Apakah Anda yakin ingin menghapus aktivitas ini?" 
                                            confirm-button-text="Ya"
                                            cancel-button-text="Tidak"
                                            @confirm="deleteFlow(scope)"
                                        >
                                            <template #reference>
                                                <el-button 
                                                    size="small" 
                                                    type="danger"
                                                    style="background-color: #F56C6C; border-color: #F56C6C; color: white;"
                                                    @click.stop=""
                                                >
                                                    <el-icon><Delete /></el-icon>
                                                </el-button>
                                            </template>
                                        </el-popconfirm>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>

            <!-- Flow Details Section -->
            <el-col :md="16">
                <el-card shadow="never" v-if="selectedFlow.id" v-loading="loadingField">
                    <template #header>
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <div style="display: flex; align-items: center;">
                                <el-icon style="margin-right: 8px; color: #409EFF;"><DocumentCopy /></el-icon>
                                <div>
                                    <span style="font-weight: bold; font-size: 16px;">
                                        {{ selectedFlow.group_name }} - {{ selectedFlow.flow_name }}
                                    </span>
                                    <p style="margin: 5px 0 0 0; color: #909399; font-size: 14px;">
                                        Tabel: {{ selectedFlow.table_name }} | {{ selectedFlow.description || 'Tidak ada deskripsi' }}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <el-button 
                                    size="small"
                                    @click="loadFromTable()"
                                    :icon="Refresh"
                                >
                                    Muat dari Tabel
                                </el-button>
                                <el-button 
                                    type="primary" 
                                    size="small"
                                    @click="savePageDetail()"
                                    :loading="savingFields"
                                    style="background-color: #67C23A; border-color: #67C23A; color: white;"
                                >
                                    <el-icon style="margin-right: 5px;"><Check /></el-icon>
                                    Simpan Konfigurasi
                                </el-button>
                            </div>
                        </div>
                    </template>

                    <!-- Field Configuration Table -->
                    <div class="field-configuration">
                        <el-table :data="fieldList" style="width: 100%" :stripe="true">
                            <el-table-column type="index" width="50" label="No" align="center" />
                            <el-table-column prop="field_name" label="Nama Field" width="150">
                                <template #default="scope">
                                    <el-tooltip :content="scope.row.validations || 'Tidak ada validasi'" placement="top">
                                        <span style="cursor: help;">{{ scope.row.field_name }}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="field_title" label="Label" width="180">
                                <template #default="scope">
                                    <el-input 
                                        v-model="scope.row.field_title" 
                                        size="small"
                                        placeholder="Label field"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="field_type" label="Tipe" width="180">
                                <template #default="scope">
                                    <el-select 
                                        v-model="scope.row.field_type" 
                                        size="small"
                                        style="width: 100%"
                                    >
                                        <el-option 
                                            v-for="item in field_type_options" 
                                            :key="item.value" 
                                            :label="item.label"
                                            :value="item.value" 
                                        />
                                    </el-select>
                                    <el-select 
                                        v-if="scope.row.field_type=='select'" 
                                        v-model="scope.row.options_lov" 
                                        size="small"
                                        style="width: 100%; margin-top: 5px;"
                                        placeholder="Pilih LOV"
                                    >
                                        <el-option 
                                            v-for="lov in lovList" 
                                            :key="lov.lov_id" 
                                            :label="lov.lov_id"
                                            :value="lov.lov_id" 
                                        />
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="field_order" label="Urutan" width="100" align="center">
                                <template #default="scope">
                                    <el-input-number 
                                        v-model="scope.row.field_order" 
                                        :min="0" 
                                        :max="999"
                                        size="small"
                                        controls-position="right"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="show" label="Tampil" width="100" align="center">
                                <template #default="scope">
                                    <el-switch
                                        v-model="scope.row.show"
                                        active-value="Yes"
                                        inactive-value="No"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="required" label="Wajib" width="100" align="center">
                                <template #default="scope">
                                    <el-switch
                                        v-model="scope.row.required"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column prop="field_description" label="Deskripsi" min-width="200">
                                <template #default="scope">
                                    <el-input 
                                        v-model="scope.row.field_description" 
                                        size="small"
                                        placeholder="Deskripsi field"
                                    />
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>

                <!-- Empty State -->
                <el-card shadow="never" v-else>
                    <el-empty description="Pilih aktivitas untuk melihat dan mengelola konfigurasi field" />
                </el-card>
            </el-col>
        </el-row>

        <!-- Flow Dialog -->
        <el-dialog 
            v-model="dialogFormVisible" 
            :title="selectedFlow.id ? 'Ubah Aktivitas' : 'Tambah Aktivitas Baru'" 
            width="700px"
            :close-on-click-modal="false"
        >
            <el-form 
                :model="selectedFlow" 
                label-width="160px" 
                :rules="FlowRules" 
                ref="ruleFlowForm"
                label-position="right"
            >
                <el-form-item label="Nama Aktivitas" prop="flow_name">
                    <el-input 
                        v-model="selectedFlow.flow_name" 
                        placeholder="Masukkan nama aktivitas"
                    />
                </el-form-item>
                <el-form-item label="Nama Grup" prop="group_name">
                    <el-input 
                        v-model="selectedFlow.group_name" 
                        placeholder="Masukkan nama grup (contoh: Master Data, Transaksi)"
                    />
                </el-form-item>
                <el-form-item label="Nama Tabel" prop="table_name">
                    <el-select 
                        v-model="selectedFlow.table_name" 
                        @change="selectTable" 
                        placeholder="Pilih tabel database"
                        style="width: 100%"
                        filterable
                        :loading="loadingTables"
                    >
                        <el-option 
                            v-for="item in tableList" 
                            :key="item.table_name" 
                            :label="item.table_name"
                            :value="item.table_name" 
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="Field Utama" prop="main_fields">
                    <el-select 
                        v-model="selectedFlow.main_fields" 
                        multiple 
                        placeholder="Pilih field yang akan ditampilkan sebagai identitas"
                        style="width: 100%"
                    >
                        <el-option 
                            v-for="item in mainfieldList" 
                            :key="item.field_name" 
                            :label="item.field_name"
                            :value="item.field_name" 
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="Opsi Kategori" prop="category_lov">
                    <el-select 
                        v-model="selectedFlow.category_lov" 
                        clearable 
                        placeholder="Pilih LOV untuk kategori (opsional)"
                        style="width: 100%"
                    >
                        <el-option 
                            v-for="item in lovList" 
                            :key="item.lov_id" 
                            :label="item.lov_id" 
                            :value="item.lov_id" 
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="Aktivitas Anak" prop="child_flow_id">
                    <el-select 
                        v-model="selectedFlow.child_flow_id" 
                        clearable 
                        placeholder="Pilih aktivitas anak (opsional)"
                        style="width: 100%"
                    >
                        <el-option 
                            v-for="item in flowList" 
                            :key="item.id" 
                            :label="item.group_name + ' - ' + item.flow_name" 
                            :value="item.id" 
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="Deskripsi" prop="description">
                    <el-input 
                        v-model="selectedFlow.description" 
                        type="textarea"
                        :rows="3"
                        placeholder="Masukkan deskripsi aktivitas (opsional)"
                    />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">Batal</el-button>
                    <el-button 
                        type="primary" 
                        @click="selectedFlow.id ? editFlow() : addFlow()"
                        :loading="submitting"
                    >
                        {{ selectedFlow.id ? 'Simpan' : 'Tambah' }}
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { 
    Plus, Edit, Delete, Check, DocumentCopy, Refresh
} from '@element-plus/icons-vue'

export default {
    name: 'FlowView',
    data() {
        return {
            Plus, Edit, Delete, Check, DocumentCopy, Refresh,
            tableList: [],
            fieldList: [],
            mainfieldList: [],
            lovList: [],
            fieldListTable: [],
            flowList: [],
            selectedFlow: {},
            loadFieldState: { table: false, flow: false },
            flowFieldChanged: false,
            dialogFormVisible: false,
            loadingFlow: false,
            loadingField: false,
            loadingTables: false,
            savingFields: false,
            submitting: false,
            field_type_options: [
                { value: 'text', label: 'Teks' },
                { value: 'paragraph', label: 'Paragraf' },
                { value: 'number', label: 'Angka' },
                { value: 'datetime', label: 'Tanggal/Waktu' },
                { value: 'select', label: 'Pilihan' },
                { value: 'image', label: 'Gambar' },
                { value: 'coordinate', label: 'Koordinat' },
                { value: 'url', label: 'URL' },
                { value: 'file', label: 'Berkas' },
            ],
            FlowRules: {
                flow_name: [
                    { required: true, message: 'Harap masukkan nama aktivitas', trigger: 'blur' },
                    { min: 3, message: 'Nama aktivitas minimal 3 karakter', trigger: 'blur' }
                ],
                group_name: [
                    { required: true, message: 'Harap masukkan nama grup', trigger: 'blur' }
                ],
                table_name: [
                    { required: true, message: 'Harap pilih tabel', trigger: 'change' }
                ],
                description: [
                    { required: false, message: 'Harap masukkan deskripsi', trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        apiHeaders() {
            return {
                'Authorization': `Bearer ${this.$store.state.auth_token}`
            }
        },
        baseUrl() {
            return this.$store.state.base_url
        }
    },
    mounted() {
        this.getFlow()
        this.getTable()
        this.getLOVList()
    },
    methods: {
        async getTable() {
            this.loadingTables = true
            try {
                const response = await axios.get(`${this.baseUrl}/api/spf/tables`, {
                    headers: this.apiHeaders
                })
                this.tableList = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil daftar tabel')
            } finally {
                this.loadingTables = false
            }
        },
        
        async getField(table_name) {
            try {
                const response = await axios.get(`${this.baseUrl}/api/spf/fields/${table_name}`, {
                    headers: this.apiHeaders
                })
                
                this.fieldListTable = response.data.data
                this.loadFieldState.table = true
                this.compareFieldTable()
            } catch (error) {
                this.handleError(error, 'Gagal mengambil field tabel')
            }
        },
        
        async getMainFieldTable(table_name) {
            try {
                const response = await axios.get(`${this.baseUrl}/api/spf/fields/${table_name}`, {
                    headers: this.apiHeaders
                })
                this.mainfieldList = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil field utama')
            }
        },
        
        async getLOVList() {
            try {
                const response = await axios.get(`${this.baseUrl}/api/lov_list`, {
                    headers: this.apiHeaders
                })
                this.lovList = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil daftar LOV')
            }
        },
        
        async getPageById(spf_flow_id) {
            this.loadingField = true
            try {
                const response = await axios.get(`${this.baseUrl}/api/page/default/${spf_flow_id}`, {
                    headers: this.apiHeaders
                })
                
                this.fieldList = response.data.fields || []
                this.loadFieldState.flow = true
                this.compareFieldTable()
            } catch (error) {
                this.handleError(error, 'Gagal mengambil konfigurasi field')
            } finally {
                this.loadingField = false
            }
        },
        
        compareFieldTable() {
            if (this.loadFieldState.table && this.loadFieldState.flow) {
                if (this.fieldList.length === 0) {
                    this.fieldList = this.fieldListTable.map(field => ({
                        ...field,
                        field_title: field.field_name,
                        field_type: 'text',
                        field_order: 0,
                        show: 'Yes',
                        required: 0,
                        field_description: ''
                    }))
                    this.flowFieldChanged = true
                } else {
                    this.flowFieldChanged = false
                }
            }
        },
        
        loadFromTable() {
            this.fieldList = this.fieldListTable.map(field => ({
                ...field,
                field_title: field.field_name,
                field_type: 'text',
                field_order: 0,
                show: 'Yes',
                required: 0,
                field_description: ''
            }))
            this.flowFieldChanged = true
            ElMessage({
                message: 'Field berhasil dimuat dari tabel',
                type: 'success'
            })
        },
        
        async getFlow() {
            this.loadingFlow = true
            try {
                const response = await axios.get(`${this.baseUrl}/api/flows`, {
                    headers: this.apiHeaders
                })
                
                this.flowList = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data aktivitas')
            } finally {
                this.loadingFlow = false
            }
        },
        
        selectFlow(row) {
            this.flowFieldChanged = false
            this.fieldList = []
            this.selectedFlow = row
            this.loadFieldState = { table: false, flow: false }
            this.getField(this.selectedFlow.table_name)
            this.getPageById(row.id)
        },
        
        selectTable(table_name) {
            this.getMainFieldTable(table_name)
        },
        
        showAddFlow() {
            this.resetFlowForm()
            this.dialogFormVisible = true
        },
        
        showEditFlow(selected) {
            this.selectedFlow = { ...selected.row }
            if (this.selectedFlow.main_fields) {
                this.selectedFlow.main_fields = this.selectedFlow.main_fields.split(',')
            }
            this.getMainFieldTable(this.selectedFlow.table_name)
            this.dialogFormVisible = true
        },
        
        resetFlowForm() {
            this.selectedFlow = { 
                id: '',
                flow_name: '',
                group_name: '',
                table_name: '',
                main_fields: [],
                category_lov: '',
                child_flow_id: '',
                description: ''
            }
            this.mainfieldList = []
        },
        
        async addFlow() {
            try {
                const valid = await this.$refs['ruleFlowForm'].validate()
                if (!valid) return
                
                this.submitting = true
                const postData = {
                    ...this.selectedFlow,
                    main_fields: Array.isArray(this.selectedFlow.main_fields) 
                        ? this.selectedFlow.main_fields.join(',') 
                        : this.selectedFlow.main_fields
                }
                
                await axios.post(`${this.baseUrl}/api/flow`, postData, {
                    headers: this.apiHeaders
                })
                
                ElMessage({
                    message: 'Aktivitas berhasil ditambahkan!',
                    type: 'success'
                })
                this.dialogFormVisible = false
                this.getFlow()
            } catch (error) {
                this.handleError(error, 'Gagal menambahkan aktivitas')
            } finally {
                this.submitting = false
            }
        },
        
        async editFlow() {
            try {
                const valid = await this.$refs['ruleFlowForm'].validate()
                if (!valid) return
                
                this.submitting = true
                const postData = {
                    ...this.selectedFlow,
                    main_fields: Array.isArray(this.selectedFlow.main_fields) 
                        ? this.selectedFlow.main_fields.join(',') 
                        : this.selectedFlow.main_fields
                }
                
                await axios.put(`${this.baseUrl}/api/flow/${this.selectedFlow.id}`, postData, {
                    headers: this.apiHeaders
                })
                
                this.dialogFormVisible = false
                ElMessage({
                    message: 'Aktivitas berhasil diperbarui!',
                    type: 'success'
                })
                this.getFlow()
            } catch (error) {
                this.handleError(error)
            } finally {
                this.submitting = false
            }
        },
        
        async deleteFlow(selected) {
            this.loadingFlow = true
            try {
                await axios.delete(`${this.baseUrl}/api/flow/${selected.row.id}`, {
                    headers: this.apiHeaders
                })
                
                ElMessage({
                    message: 'Aktivitas berhasil dihapus!',
                    type: 'success'
                })
                this.getFlow()
                
                if (this.selectedFlow.id === selected.row.id) {
                    this.selectedFlow = {}
                    this.fieldList = []
                }
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loadingFlow = false
            }
        },
        
        async savePageDetail() {
            this.savingFields = true
            try {
                const postData = {
                    spf_flow_id: this.selectedFlow.id,
                    spf_page_id: 'default',
                    fields: this.fieldList
                }
                
                await axios.post(`${this.baseUrl}/api/page/fields`, postData, {
                    headers: this.apiHeaders
                })
                
                ElMessage({
                    message: 'Konfigurasi field berhasil disimpan!',
                    type: 'success'
                })
                this.flowFieldChanged = false
            } catch (error) {
                this.handleError(error, 'Gagal menyimpan konfigurasi field')
            } finally {
                this.savingFields = false
            }
        },
        
        handleError(error, defaultMessage = '') {
            const message = error.response?.data?.message || defaultMessage || 'Terjadi kesalahan'
            ElMessage({
                message,
                type: 'error'
            })
            console.error('Error:', error)
        }
    }
}
</script>

<style scoped>
.flow-management-container {
    padding: 20px;
}

.header-card {
    margin-bottom: 20px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.field-configuration {
    padding: 10px;
}

.el-table {
    cursor: pointer;
}

.el-table__row:hover {
    background-color: #f5f7fa !important;
}

@media (max-width: 768px) {
    .flow-management-container {
        padding: 10px;
    }
    
    .el-dialog {
        width: 90% !important;
    }
    
    .el-col-md-8,
    .el-col-md-16 {
        margin-bottom: 20px;
    }
}
</style>